import '@fontsource-variable/roboto'

import { reloadOnFailedChunk } from './Common/base/appVersion'
import { loadEnvironment } from './Common/environment'

reloadOnFailedChunk()

loadEnvironment()
    .catch(() => undefined)
    .then(() => import('./Common/base/initApp'))
    .then(({ default: initApp }) => initApp())
